// extracted by mini-css-extract-plugin
module.exports = {"select":"StandardSelect_select__2GAq5","root":"StandardSelect_root__3MB4T","icon":"StandardSelect_icon__1ItSa"};